<style scoped lang="scss">

</style>
<template>
	<div class="node-container" style="display: flex;flex-wrap: nowrap;width: 100%;">
		<div style="border: 1px #419FFF solid;width: 4px;height: 38px;background-color: #419FFF;border-radius: 10px 0 0 10px;">
		</div>
		<div style="border: 1px #d1d1d1 solid;flex:1;height: 38px;background-color: white;" size="mini" :style="{ backgroundColor: currentNodeId === item.id ? '#D9ECFF' : '' }" @click="add()">
			<span style="display: flex;justify-content: center;align-items: center;padding-top: 10px;">{{ item.workProcedureDesc }}</span>
		</div>
	</div>

</template>

<script>
	export default {
		name: "web_components_craft_node1",
		inject: ["getGraph", "getNode"],
		data() {
			return {
				radio1: '',
				priority: null,
				item: {},
				index: null,
				currentNodeId: null,
				// t:null,
				miStatusColor(val) {
					if (val == 'selectIndex') {
						return '#409eff'
					} else {
						return '#FEF0F0'
					}
				},
			};
		},
		computed: {
			
		},
		mounted() {
			const self = this;
			const node = this.getNode();
			//监听数据改变事件
			node.on("change:data", ({
				current
			}) => {
				self.priority = current.priority;
				self.item = current.item
				self.currentNodeId = current.currentNodeId
			});

			//初次进入的时候赋值外面传入的数据
			this.priority = node.getData().priority;
			this.item = node.getData().item;
			this.currentNodeId = node.getData().currentNodeId;
		},
		methods: {
			add() {
				this.utils.event_hub.$emit('node3Tap', {
					item: this.item
				});
				// const node = this.getNode();
				// const { num } = node.getData();
				// node.setData({
				//   num: num + 1,
				// });
			},
		},
	};
</script>
